module.exports = __webpack_public_path__ + "static/mask_lo_106-d712f77dd0994982a4dc3311766ee0a5.jpg";